import { isNumber } from 'lodash';

import { $gt } from '@/common/appCtx';

export const workstationIdColumn = {
  get title() { return $gt('Workstation ID'); },
  dataIndex: 'biz_workstation_id',
  width: 120,
  key: 'biz_workstation_id',
};

export const workstationNameColumn = {
  get title() { return $gt('Workstation Name'); },
  dataIndex: 'workstation_name',
  width: 120,
  key: 'workstation_name',
};

export const activityTypeColumn = {
  get title() { return $gt('Activity Type'); },
  dataIndex: 'activity_str',
  width: 120,
  key: 'activity_str',
};

export const subCriteriaColumn = {
  get title() { return $gt('Sub-Criteria'); },
  dataIndex: 'sub_criteria_str',
  ellipsis: true,
  lineClamp: 2,
  width: 120,
  key: 'sub_criteria_str',
};

export const linkedMachineAccountColumn = {
  get title() { return $gt('Linked Machine Account'); },
  dataIndex: 'account_list_str',
  ellipsis: true,
  lineClamp: 2,
  width: 120,
  key: 'account_list_str',
};

export const parcelTypeColumn = {
  get title() { return $gt('Parcel Type'); },
  dataIndex: 'parcel_type',
  width: 120,
  key: 'parcel_type',
};

export const areaColumn = {
  get title() { return $gt('Area'); },
  dataIndex: 'area_name',
  width: 120,
  key: 'area_name',
};

export const linkedWorkstationColumn = {
  get title() { return $gt('Linked Workstation(Active)'); },
  dataIndex: 'linked_workstation_str',
  ellipsis: true,
  lineClamp: 2,
  width: 120,
  key: 'linked_workstation_str',
};

export const workstationTargetColumn = {
  get title() { return $gt('Workstation Target'); },
  dataIndex: 'workstation_target',
  width: 120,
  key: 'workstation_target',
  render: (val: any) => {
    return val && val !== '0' ? val : '-';
  },
};

export const operatorTargetColumn = {
  get title() { return $gt('Operator Target'); },
  dataIndex: 'operator_target',
  width: 120,
  key: 'operator_target',
  render: (val: any) => {
    return val && val !== '0' ? val : '-';
  },
};

export const uploadResultColumn = {
  get title() { return $gt('Upload Result'); },
  dataIndex: 'upload_result',
  width: 120,
  key: 'upload_result',
};

export const errorTypeColumn = {
  get title() { return $gt('Error Type'); },
  dataIndex: 'error_type',
  ellipsis: true,
  lineClamp: 2,
  width: 120,
  key: 'error_type',
};

export const createColumns = [
  workstationNameColumn,
  activityTypeColumn,
  subCriteriaColumn,
  linkedMachineAccountColumn,
  parcelTypeColumn,
  areaColumn,
  linkedWorkstationColumn,
  workstationTargetColumn,
  operatorTargetColumn,
  uploadResultColumn,
  errorTypeColumn,
];

export const editColumns = [workstationIdColumn].concat(createColumns);

export const deleteColumns = [
  workstationIdColumn,
  uploadResultColumn,
  errorTypeColumn,
];
